import {styled} from '@linaria/react';

/**
 * Shared masked layer used by SaleCloudIcon and SaleTagIcon to paint a colour
 * (background/foreground) through an SVG mask. Internal to ui-components —
 * not exported from the package index.
 */
export const MaskLayer = styled.div<{$iconUrl: string}>`
  position: absolute;
  inset: 0;
  mask-image: ${({$iconUrl}) => `url(${$iconUrl})`};
  mask-repeat: no-repeat;
  mask-size: 100%;
`;
